// extracted by mini-css-extract-plugin
export default {"main":"BGMenu_main__ANr4z","menu":"BGMenu_menu__xOEPS","header":"BGMenu_header__lTyGT","divider":"BGMenu_divider__LuD67"};